/**
 * ProtectedRoute
 * Auto-generated - Auth Tokens Infrastructure Component
 *
 * Wraps routes that require authentication and optional role checking.
 * Redirects to /login if not authenticated.
 * Redirects to /access-denied if authenticated but wrong role.
 *
 * Consumes auth state via the useAuth hook (hooks/useAuth.ts) which reads
 * from AuthProvider.tsx — the single source of truth when auth_tokens is
 * enabled.  AuthProvider integrates with api-client.ts so Bearer tokens
 * are attached automatically.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
  redirectTo?: string;
}

export function ProtectedRoute({ children, roles, redirectTo = "/login" }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Role check: if roles specified, verify user has one of them
  if (roles && roles.length > 0 && user) {
    const userRole = (user as Record<string, unknown>).role as string;
    if (!roles.includes(userRole)) {
      return <Navigate to="/access-denied" replace />;
    }
  }

  return <>{children}</>;
}